<div class="cm-button-dropdown">
  <button
    #button
    type="button"
    class="cm-button-dropdown__trigger"
    [class]="buttonClasses()"
    [disabled]="disabled()"
    [attr.id]="autId()"
    [attr.aria-label]="label()"
    [attr.aria-haspopup]="'menu'"
    [attr.aria-expanded]="isOpen()"
    [attr.aut-id]="autId()"
    (click)="toggleDropdown()"
    (keydown)="onButtonKeydown($event)"
  >
    <span class="cm-button-dropdown__content">
      <cm-icon [name]="icon()" class="cm-button-dropdown__icon" />
      <span class="cm-button-dropdown__label">{{ label() }}</span>
      <cm-icon
        [name]="isOpen() ? 'expand_less' : 'expand_more'"
        class="cm-button-dropdown__arrow"
      />
    </span>
  </button>

  @if (isOpen()) {
    <div
      #dropdown
      class="cm-button-dropdown__menu"
      role="menu"
      [attr.aria-labelledby]="autId()"
    >
      @for (action of actions(); track action.id; let i = $index) {
        <button
          type="button"
          class="cm-button-dropdown__item"
          [class.cm-button-dropdown__item--focused]="focusedIndex() === i"
          [class.cm-button-dropdown__item--disabled]="action.disabled"
          role="menuitem"
          [disabled]="action.disabled"
          [tabindex]="focusedIndex() === i ? 0 : -1"
          [attr.aut-id]="autId() + '-action-' + action.id"
          (click)="onActionClick(action.id, action.disabled)"
          (keydown)="onMenuKeydown($event, i)"
        >
          @if (action.icon) {
            <cm-icon [name]="action.icon" class="cm-button-dropdown__item-icon" />
          }
          <span class="cm-button-dropdown__item-label">{{ action.label }}</span>
        </button>
      }
    </div>
  }
</div>
